'use strict';

export default class c {
  constructor(patterns, contact) {
    'ngInject';

    this.emailPattern = new RegExp(patterns.email);
    this.contactModel = contact;
  }

  submit() {
    this.isSaving = true;
    this.contactModel.sendMessage(this.data)
      .then(() => this.isMessageSent = true)
      .finally(() => delete this.isSaving);
  }
}



// WEBPACK FOOTER //
// ./app/src/common/contact_form/contact_form.ctrl.js